import React from 'react'
import { object } from 'prop-types'
import Config from '../../../../../config/generatedConfig'
import ReduxStores from '../../../../stores/connects'
import Helpers from '../../../../../_plugins/lib/helpers'
import classNames from 'classnames'
import request from 'superagent'

class SmsForm extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      userNumber: '',
      callBackMsg: '',
      formVisible: true,
      errMsg: false,
      disabled: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.updateValue = this.updateValue.bind(this)
    this.smsCallback = this.smsCallback.bind(this)
    this.handleSendAnother = this.handleSendAnother.bind(this)
    this.forceFormSubmit = this.forceFormSubmit.bind(this)
  }

  componentDidMount () {
    this.getUserContactNumber()
  }

  smsCallback (err, result) {
    let newState = this.state
    newState['formVisible'] = false
    newState['errMsg'] = false

    if (err || !result.text) {
      newState['callBackMsg'] = 'Sorry, something went wrong.'
      newState['errMsg'] = true
    } else {
      newState['callBackMsg'] = 'SMS sent!'
    }
    this.setState(newState)
    document.querySelector('.smsMsg').classList.add('jelly')
    if (this.props.customCallback) this.props.customCallback(newState)
  }

  getUserContactNumber () {
    const { loggedInData = {} } = this.props
    const loggedInStatus = loggedInData.hasOwnProperty('email')
    if (!loggedInStatus && !loggedInData.contact_number) return
    let phoneNumber = loggedInData.contact_number
    if (phoneNumber.substring(0, 2) !== '07' && phoneNumber.substring(0, 4) !== '+447') return
    this.setState({ userNumber: phoneNumber }, this.forceFormSubmit)
  }

  forceFormSubmit () {
    if (Helpers.getCookie('SMSForcedSubmit')) return
    Helpers.setCookie('SMSForcedSubmit', 1)
    document.querySelector('#SmsForm button').click()
  }

  updateValue (e) {
    this.setState({
      userNumber: e.target.value
    })
  }

  handleSendAnother (e) {
    e.preventDefault()
    this.setState({
      formVisible: true,
      disabled: false,
      userNumber: ''
    })
  }

  validatePhoneNumber () {
    const { userNumber } = this.state
    const mobileNumber = $.trim(userNumber)
    const phoneNumberRegex = /((\+44?)|0)7\d{3}?\d{6}/g

    const validPhoneNumber = !!mobileNumber.match(phoneNumberRegex) && mobileNumber !== ''

    if (!validPhoneNumber) alert('Please enter a valid mobile number')
    return validPhoneNumber
  }

  handleSubmit (e) {
    e.preventDefault()
    this.setState({ disabled: true })
    const { agentData, pageData = {} } = this.props
    const appSettings = Config.appSettings
    const { userNumber } = this.state
    const validPhoneNumber = this.validatePhoneNumber()
    const campaign = pageData.pageName === 'holiday-extras-mobile-app-cc' ? 'care-cc-agent' : appSettings.campaign
    if (!userNumber && !validPhoneNumber) return

    const formData = {
      phone: userNumber,
      agent: agentData.agent,
      campaign: campaign
    }

    try {
      request
        .post('https://' + Config.domainSettings.domain + '/SMSProxy.php')
        .query(formData)
        .set('Access-Control-Allow-Origin', '*')
        .set('accept', 'json')
        .withCredentials()
        .end(this.smsCallback)
    } catch (e) {
      this.setState({ errMsg: true })
      console.log(e)
    }
  }

  render () {
    const { id, agentData, formTitle, buttonText } = this.props
    const { userNumber, formVisible, callBackMsg, errMsg, disabled } = this.state
    const resultClassNames = classNames('smsMsg', 'text-center', {
      'error': errMsg
    })

    return (
      <div id={id}>
        {formVisible && (
          <div>
            <h3>{formTitle}</h3>
            <form id='SmsForm' onSubmit={this.handleSubmit} method='get'>
              <div className='form-group'>
                <input id='phone' name='phone' type='tel' placeholder='Enter a UK mobile number' className='form-control' pattern='((\+44?)|0)7\d{3}?\d{6}' onChange={this.updateValue} value={userNumber} required />
                <span className='validity' />
              </div>
              <button className='btn btn-primary hx-btn-ultimate sms-btn' type='submit' data-hxtrack-name='sms_link' disabled={disabled}>
                {disabled && <span className='btn-text'>Sending...</span>}
                {!disabled && <span className='btn-text'>{buttonText}</span>}
              </button>
              <input type='hidden' name='agent' defaultValue={agentData.agent} />
            </form>
          </div>
        )}
        {!formVisible &&
        <div className='smsResp'>
          <h4 className={resultClassNames}>{callBackMsg}</h4>
          <p className='sendAnother'><a onClick={this.handleSendAnother} title='send another sms' className='sendAnother pull-right'>Send another SMS</a></p>
        </div>
        }
      </div>
    )
  }
}

SmsForm.propTypes = {
  agentData: object
}
SmsForm.defaultProps = {
  formTitle: `We'll send a link via SMS to your mobile`,
  buttonText: 'Send link to my phone'
}

// export default SmsForm

export default ReduxStores(SmsForm, ['login'], true)



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/content/sendSMSFormAQL.jsx